import React, { PureComponent } from 'react';

import styled from 'styled-components';

import { BilibiliIcon } from '../atoms/Socials/BilibiliIcon';
import Button from '../atoms/Button/Button';
import ExternalLink from '../atoms/ExternalLink/ExternalLink';
import { FacebookIcon } from '../atoms/Socials/FacebookIcon';
import { InstagramIcon } from '../atoms/Socials/InstagramIcon';
import { LinkedinIcon } from '@components/atoms/Socials/LinkedinIcon';
import Loader from '../atoms/Loader/Loader';
import { MiniProgramIcon } from '../atoms/Socials/MiniProgramIcon';
import { RedbookIcon } from '../atoms/Socials/RedbookIcon';
import { TwitterIcon } from '../atoms/Socials/TwitterIcon';
import { WeChatIcon } from '../atoms/Socials/WeChatIcon';
import { YoutubeIcon } from '../atoms/Socials/YoutubeIcon';
import WeChatQRCodePopup from '@components/organisms/WeChatQRCodePopup';

import { I18nTranslation } from '@shared/interfaces/i18n';
import { MEDIA_POINT } from 'theme';
import { Target } from '@shared/enums/target';
import { withTranslation } from 'i18n';

const ExternalLinkExtend = styled(ExternalLink)`
  padding: 0.75em 0.1em;
  margin: 0em 0.5em 2em 0.5em;
  display: inline-block;
  height: 36px;
  max-width: 3.125em;
  color: inherit;
  transition: color 0.2s;

  &:hover {
    color: ${props => props.theme.colors.white};
  }
`;

const WeChatButton = styled(Button)`
  padding: 0.75em 0;
  display: inline-block;
  width: 45%;
  max-width: 3.125em;
  color: inherit;
  transition: color 0.2s;
  &:hover {
    color: ${props => props.theme.colors.white};
  }
  @media screen and (min-width: ${MEDIA_POINT.M}px) {
    text-align: start;
  }

  margin: 1em 0.5em;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin: -5px;
`;

const StyledLoader = styled(Loader)`
  margin: 0.75em;
`;

type Network = {
  id: number;
  Svg: React.FC<{}>;
  href: string;
  isWeChat?: boolean;
};

type SocialNetworksProps = {
  className?: string;
  isMobile?: boolean;
  isLoadingCountry: boolean;
  isChinaLocation: boolean;
  t: I18nTranslation;
};

class SocialNetworks extends PureComponent<SocialNetworksProps> {
  state = {
    isOpenPopup: false,
  };

  networks: Network[] = [
    {
      id: 1,
      Svg: InstagramIcon,
      href: 'https://www.instagram.com/completeanatomyelsevier',
    },
    {
      id: 2,
      Svg: FacebookIcon,
      href: 'https://www.facebook.com/CompleteAnatomyElsevier/',
    },

    {
      id: 3,
      Svg: YoutubeIcon,
      href: 'https://www.youtube.com/channel/UC6jEF1orhgER1Nsc174FwTg',
    },
    {
      id: 4,
      Svg: TwitterIcon,
      href: 'https://twitter.com/CompleteAnatomy',
    },
    {
      id: 5,
      Svg: LinkedinIcon,
      href: 'https://www.linkedin.com/company/completeanatomy',
    },
  ];

  chinaNetworks: Network[] = [
    {
      id: 1,
      Svg: WeChatIcon,
      href: '',
      isWeChat: true,
    },
    {
      id: 2,
      Svg: BilibiliIcon,
      href: 'https://space.bilibili.com/37923876?from=search&seid=12692546011419727017',
    },
    {
      id: 3,
      Svg: RedbookIcon,
      href: 'https://www.xiaohongshu.com/user/profile/5eb3b460000000000100735d?xhsshare=CopyLink&appuid=5eb3b460000000000100735d&apptime=1610364563',
    },
    {
      id: 4,
      Svg: MiniProgramIcon,
      href: 'https://erzkh.duanshu.com/#/brief/column/d487623104fa4fcc906cf22ad6709d7a/',
    },
  ];

  onOpenPopup = () => {
    this.setState({
      isOpenPopup: true,
    });
  };

  onClosePopup = () => {
    this.setState({
      isOpenPopup: false,
    });
  };

  render() {
    const { className } = this.props;
    const currentNetworks = this.props.isChinaLocation
      ? this.chinaNetworks
      : this.networks;

    return (
      <div className={className}>
        <Wrapper>
          {this.props.isLoadingCountry ? (
            <StyledLoader />
          ) : (
            currentNetworks.map(network => {
              const { Svg } = network;

              return network.isWeChat ? (
                <WeChatButton key={network.id} onClick={this.onOpenPopup}>
                  <Svg />
                </WeChatButton>
              ) : (
                <ExternalLinkExtend
                  key={network.id}
                  href={network.href}
                  target={Target.Blank}
                >
                  <Svg />
                </ExternalLinkExtend>
              );
            })
          )}
        </Wrapper>
        {this.state.isOpenPopup && (
          <WeChatQRCodePopup onClose={this.onClosePopup} />
        )}
      </div>
    );
  }
}

const styledSocialNetworks = styled(withTranslation('common')(SocialNetworks))`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;

  @media (max-width: ${MEDIA_POINT.MM}px) {
    justify-content: center;
    padding-bottom: 1.5em;
  }
`;

export default styledSocialNetworks;
